import React, { useEffect } from 'react';

import useAppState  from './useAppState'
import NavReport from './NavReport/NavReport';

import { DashUserMain } from './DashUser.Style';
import LeftNav from './LeftNav/LeftNav';
import DashPage from './DashPage/DashPage';

const DashUser = (props) => {
  const { state, actions } = useAppState();
  console.log(props.state)

  // let fetchData = async () => {
    
  //   let userLogged = await localStorage.getItem('user') ? JSON.parse(await localStorage.getItem('user')) : props.state; 
  //   let tokenUserLogged = userLogged.token
  //   let userId =  props.adminPetition ? props.adminPetition.id : userLogged._id;
    
  //   await actions.getRegistersData(userId, tokenUserLogged)
  // }

  // useEffect(() => {
  //   fetchData();
  // },['props']);

  let tok = localStorage.getItem('token');
  return(
   tok ? 
    <DashUserMain>
      <LeftNav state={props.state} actions={props.actions}/>
      <NavReport state={props.state} actions={props.actions}/>
      <DashPage state={props.state} actions={props.actions} userRequested={props.userRequested}/>
    </DashUserMain>
    : 
    <div>loading...</div>
  )
};

export default DashUser;
